import { create } from 'zustand';

type State = {
  selectedOrganizationId: string;
  selectedOrganizationName: string;
  isInviteStudentsModalOpen: boolean;
  isImportStudentListModalOpen: boolean;
  isAddNewClassModalOpen: boolean;
};

type Actions = {
  setSelectedOrganizationId: (organizationId: string) => void;
  setSelectedOrganizationName: (organizationName: string) => void;
  setIsInviteStudentsModalOpen: (isOpen: boolean) => void;
  setIsImportStudentListModalOpen: (isOpen: boolean) => void;
  setIsAddNewClassModalOpen: (isOpen: boolean) => void;
  reset: () => void;
};

export const useOrganizationStore = create<State & Actions>((set) => ({
  selectedOrganizationId: '',
  selectedOrganizationName: '',
  selectedClassId: '',
  isImportStudentListModalOpen: false,
  isInviteStudentsModalOpen: false,
  isAddNewClassModalOpen: false,
  setSelectedOrganizationId: (organizationId: string) => set(() => ({ selectedOrganizationId: organizationId })),
  setSelectedOrganizationName: (organizationName: string) => set(() => ({ selectedOrganizationName: organizationName })),
  setIsImportStudentListModalOpen: (isOpen: boolean) => set(() => ({ isImportStudentListModalOpen: isOpen })),
  setIsInviteStudentsModalOpen: (isOpen: boolean) => set(() => ({ isInviteStudentsModalOpen: isOpen })),
  setIsAddNewClassModalOpen: (isOpen: boolean) => set(() => ({isAddNewClassModalOpen: isOpen})),
  reset: () => set(() => ({ selectedClassId: '', selectedOrganizationId: '' })),
}));
